module.exports = __webpack_public_path__ + "img/zhaoshang.373ae5b9.png";